<template>
  <div class="pond-map-view">
    <h2 class="page-title">
      <el-icon><Help /></el-icon>
      虾塘地图视图
    </h2>

    <PondMap
      ref="pondMapRef"
      :pond-id="null"
      :visible="true"
      :refresh-flag="refreshFlag"
      :is-standalone="true"
      :init-center="{ lng: 113.3245, lat: 23.1061 }"
      @save-success="onMapSaveSuccess"
      @save-fail="onMapSaveFail"
    />
  </div>
</template>

<script>
import { ref } from "vue";
import { Help } from "@element-plus/icons-vue";
import PondMap from "./pondMap.vue";
import { ElMessage } from "element-plus";

export default {
  name: "PondMapView",
  components: {
    Help,
    PondMap,
  },
  setup() {
    const refreshFlag = ref(0);
    const pondMapRef = ref(null);

    const onMapSaveSuccess = () => {
      ElMessage.success("操作成功");
      refreshFlag.value += 1;
      // 保存成功后刷新地图数据
      if (pondMapRef.value) {
        pondMapRef.value.fetchExistingPonds();
      }
    };

    const onMapSaveFail = (message) => {
      ElMessage.error(message || "操作失败");
    };

    return {
      refreshFlag,
      pondMapRef,
      onMapSaveSuccess,
      onMapSaveFail,
    };
  },
};
</script>

<style scoped>
.pond-map-view {
  background-color: #fff;
  min-height: calc(100vh - 60px);
  padding: 20px;
}

.page-title {
  font-size: 20px;
  margin-bottom: 20px;
  color: #1b9a7c;
  padding-bottom: 10px;
  border-bottom: 1px solid #e0e0e0;
  display: flex;
  align-items: center;
  gap: 8px;
}

.page-title .el-icon {
  font-size: 24px;
}

:deep(.amap-container) {
  width: 100%;
  height: calc(100vh - 140px);
  overflow: hidden;
}
</style>
